import { render, staticRenderFns } from "./DrugAlcoholTest.vue?vue&type=template&id=47c7e09b&scoped=true&"
import script from "./DrugAlcoholTest.vue?vue&type=script&lang=js&"
export * from "./DrugAlcoholTest.vue?vue&type=script&lang=js&"
import style0 from "./DrugAlcoholTest.vue?vue&type=style&index=0&id=47c7e09b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c7e09b",
  null
  
)

export default component.exports